import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList, faShieldAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import MyPlanModal from "./MyPlanModal";
import MyCoverageModal from "./MyCoverageModal";
import BackButton from "./BackButton";
import "./serviceUi.css";

// Plan (cyan) and Coverage (purple) keep the colours they have on the main menu.
// Benefits and Remaining Balance tiles were retired; see git history to bring them back.
const MyPlanAndBenefitsMain = ({ isOpen, onClose }) => {
  const [activeModal, setActiveModal] = useState(null);

  const handleCloseChildModal = () => setActiveModal(null);

  const handleClose = () => {
    setActiveModal(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="sheet-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="plan-coverage-title"
      onClick={(event) => event.target === event.currentTarget && handleClose()}
    >
      <div className="sheet-card">
        <BackButton onClick={handleClose} className="sheet-back" />
        <button
          type="button"
          onClick={handleClose}
          className="sheet-close"
          aria-label="Close"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <p className="sheet-eyebrow">My plan &amp; coverage</p>
        <h2 id="plan-coverage-title" className="sheet-title">
          What would you like to view?
        </h2>
        <p className="sheet-subtitle">Pick one to see the details.</p>

        <div className="menu-grid">
          <button
            type="button"
            data-action="plan"
            onClick={() => setActiveModal("plan")}
            className="menu-tile menu-tile--cyan"
            aria-label="View Plan Details"
          >
            <span className="menu-tile__icon">
              <FontAwesomeIcon icon={faClipboardList} />
            </span>
            <span className="menu-tile__label">Plan</span>
            <span className="menu-tile__hint">Your plan details</span>
          </button>
          <button
            type="button"
            data-action="coverage"
            onClick={() => setActiveModal("coverage")}
            className="menu-tile menu-tile--purple"
            aria-label="View Coverage Details"
          >
            <span className="menu-tile__icon">
              <FontAwesomeIcon icon={faShieldAlt} />
            </span>
            <span className="menu-tile__label">Coverage</span>
            <span className="menu-tile__hint">Covered services</span>
          </button>
        </div>

        {activeModal === "plan" && <MyPlanModal onClose={handleCloseChildModal} />}
        {activeModal === "coverage" && <MyCoverageModal onClose={handleCloseChildModal} />}
      </div>
    </div>
  );
};

export default MyPlanAndBenefitsMain;
